// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"766":"48105e34","787":"1584e0a8","883":"aa681ce9"}[chunkId] + ".chunk.js";
};